'use strict';

/**
 * Welcart Basic Child Theme - Main JavaScript
 */

// ============================================================
// ドキュメント準備完了後に実行
// ============================================================
document.addEventListener('DOMContentLoaded', () => {
  initMobileMenu();
  initSmoothScroll();
  initCartQuantity();
  initGallery();
});

// ============================================================
// モバイルメニュー
// ============================================================
function initMobileMenu() {
  const toggle = document.querySelector('.nav-toggle');
  const menu   = document.querySelector('.nav-menu');
  if (!toggle || !menu) return;

  toggle.addEventListener('click', () => {
    const isOpen = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!isOpen));
    menu.classList.toggle('is-open');
    document.body.classList.toggle('menu-open');
  });
}

// ============================================================
// スムーズスクロール（ページ内リンク）
// ============================================================
function initSmoothScroll() {
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', (e) => {
      const target = document.querySelector(anchor.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
}

// ============================================================
// Welcart カート数量ボタン（＋／－）
// ============================================================
function initCartQuantity() {
  document.querySelectorAll('.cart-quantity-wrap').forEach((wrap) => {
    const input = wrap.querySelector('input[type="number"]');
    if (!input) return;

    wrap.querySelector('.qty-minus')?.addEventListener('click', () => {
      const val = parseInt(input.value, 10);
      if (val > parseInt(input.min || 1, 10)) input.value = val - 1;
    });

    wrap.querySelector('.qty-plus')?.addEventListener('click', () => {
      const val = parseInt(input.value, 10);
      const max = input.max ? parseInt(input.max, 10) : Infinity;
      if (val < max) input.value = val + 1;
    });
  });
}

// ============================================================
// 商品画像ギャラリー（サムネイルクリックでメイン画像切替）
// ============================================================
function initGallery() {
  const mainImg = document.querySelector('.item-main-image img');
  if (!mainImg) return;

  document.querySelectorAll('.item-thumbnail-list img').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      mainImg.src    = thumb.dataset.large || thumb.src;
      mainImg.alt    = thumb.alt;
      document.querySelectorAll('.item-thumbnail-list li').forEach((li) =>
        li.classList.remove('is-active')
      );
      thumb.closest('li')?.classList.add('is-active');
    });
  });
}
